import { reactive } from "@vue/composition-api";

export const  URLS = reactive( {
    api_base_url: process.env.VUE_APP_API_URL,
    demo_api_base_url: process.env.VUE_APP_DEMO_API_URL,
    admin_base_url: process.env.VUE_APP_ADMIN_API_URL,
    meetup_demo_base_url: process.env.VUE_APP_MEETUP_DEMO_API_URL,
    proxyUrl:""
})